export function getCommunityUserModal(nickname) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=get_community_user_modal",
        datatype: "json",
        data: {
            "ajax_call_nickname": nickname,
            "ajax_call_sid": sid,
            "ajax_call_shop_code": shopCode
        },
        success: function (output) {
            if (!($('#community_user_profile_modal_' + nickname).length)) {
                var data = $.parseJSON(output);
                $("body").append(data);
            }
            $('#community_user_profile_modal_' + nickname).modal("show");
        }
    });
}